import { FlexWrapper, Text, Pagination, Skeleton, Separator } from '@intigral/shared';

interface SectionHeaderWithPaginationProps extends React.ComponentProps<typeof Pagination> {
    title?: string;
    isLoading?: boolean;
}

export const SectionHeaderWithPagination = ({
    title,
    isLoading = false,
    ...paginationProps
}: SectionHeaderWithPaginationProps) => {
    if (isLoading) {
        return (
            <>
                <Skeleton height={36} />
                <Separator theme="none" marginTop="1x" />
            </>
        );
    }

    return (
        <FlexWrapper gap="2x" justifyContent="between">
            <Text
                as="h2"
                variant="h2"
                alignment="start"
                margin={{ default: '2x', md: '2x' }}
                size={{ default: '18', md: '20' }}
                style={{ maxWidth: '80%', textOverflow: 'ellipsis', overflow: 'hidden', textTransform: 'lowercase' }}
                fontWeight="medium"
            >
                {title}
            </Text>
            <Pagination {...paginationProps}></Pagination>
        </FlexWrapper>
    );
};
